import { api } from "../data";
import { toast } from "./Toast";
import { promptInstall, useInstallState } from "../pwa";
import { t as uiT } from "../lib/sprache";

/**
 * Als App auf dem Startbildschirm (PWA): Knopf zum Installieren, wo der Browser es anbietet (Android, Chrome), sonst die
 * Anleitung für iPhone und iPad bzw. das Browsermenü. In beiden Portalen (Creator-Konto, Agentur-Profil; PARITAET-20, AD-010),
 * das Manifest je Portal liefert pwa.ts.
 */
export function AppInstallieren({ t = uiT, heading = "h2" }: { t?: (de: string, en: string) => string; heading?: "h2" | "h3" }) {
  const { canPrompt, standalone, apple } = useInstallState();
  const H = heading;
  return (
    <section className="panel stack" aria-labelledby="konto-app">
      <H id="konto-app">{t("Als App auf dem Startbildschirm", "As an app on your home screen")}</H>
      {standalone ? (
        <p>{t("Du nutzt das Portal gerade als App.", "You are using the portal as an app right now.")}</p>
      ) : api.mode === "demo" ? (
        <p>{t("In der Demo lässt sich das Portal nicht installieren. In der echten Anwendung legst du es hier mit einem Tipp auf den Startbildschirm.",
          "The demo cannot be installed. In the real application you add the portal to your home screen here with one tap.")}</p>
      ) : canPrompt ? (
        <>
          <p>{t("Leg das Portal wie eine App auf deinen Startbildschirm. Es öffnet sich dann ohne Browserleiste, immer im aktuellen Stand.",
            "Add the portal to your home screen like an app. It then opens without the browser bar, always up to date.")}</p>
          <div className="row">
            <button type="button" className="primary" onClick={() => void promptInstall().then((r) => r === "accepted" && toast(t("Die App ist installiert.", "The app is installed.")))}>
              {t("App installieren", "Install app")}
            </button>
          </div>
        </>
      ) : apple ? (
        <p>{t("Auf dem iPhone oder iPad: in Safari auf „Teilen“ tippen und „Zum Home-Bildschirm“ wählen.", "On iPhone or iPad: tap “Share” in Safari and choose “Add to Home Screen”.")}</p>
      ) : (
        <p>{t("Öffne das Portal am Handy im Browser und wähle im Menü „App installieren“ bzw. „Zum Startbildschirm hinzufügen“.",
          "Open the portal in your phone's browser and choose “Install app” or “Add to home screen” in the menu.")}</p>
      )}
    </section>
  );
}
